import { render, staticRenderFns } from "./ManagementBackend.vue?vue&type=template&id=4a6e5d87&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a6e5d87')) {
      api.createRecord('4a6e5d87', component.options)
    } else {
      api.reload('4a6e5d87', component.options)
    }
    module.hot.accept("./ManagementBackend.vue?vue&type=template&id=4a6e5d87&", function () {
      api.rerender('4a6e5d87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ManagementBackend.vue"
export default component.exports